import axios from 'axios'

export default {
	getImageBase64: async function (processingDocumentId) {
		const imageUrl = `/document-image?processing-document-id=${processingDocumentId}`
		const response = await axios.get(imageUrl, { responseType: 'arraybuffer' })
		const imageData = Buffer.from(response.data, 'binary').toString('base64')
		const imageMetadata = 'data:image/png;base64,'
		return imageMetadata + imageData
	}
}
